export default {
  set(key, value) {
    if (!window.sessionStorage) {
      return
    }
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  get(key) {
    let value = sessionStorage.getItem(key)
    if (!value) {
      return
    }
    return JSON.parse(value)
  },
  clear(key) {
    sessionStorage.clear(key)
  }
}



// WEBPACK FOOTER //
// ./src/base/commonJS/sessionStorage.js